/* 登入 */
export const GET_AUTH_API                = `/api/auth/`;
export const GET_LIFF_AUTH_API           = `/api/liff-auth/`;
export const GET_LOGIN_API               = `/api/login/`;
export const GET_LIFF_LOGIN_API          = `/api/member/liff-login/`;
export const GET_LIFF_LOGIN_EMPLOYEE_API = `/api/employee/liff-login/`;
export const GET_LOGOUT_API              = `/api/logout/`;

export const GET_LIFF_BINDING_API = `/api/liff-binding/`;

/* 版本號 */
export const GET_SYSTEM_BUILD_TIME_API = `/api/system/build-time/`;

/* LINE LIFF 設定值 */
export const GET_SYSTEM_LIFF_PROFILE_API = `/api/system/liff-profile/`;

/* 身份驗證 */
export const GET_ME_CHECK_API = `/api/me/check/`;
export const GET_ME_API       = `/api/me/`;
export const GET_ME_UI_ROLE_API       = `/api/me/ui-role/`;

/* 智能頁面 */
export const GET_MEMBER_DEVICE_ORDER_INFO_API   = `/api/member/device-order-info/`;
export const GET_EMPLOYEE_DEVICE_ORDER_INFO_API = `/api/employee/device-order-info/`;

/* 會員量測 */
export const GET_MEMBER_INBODY_OPTIONS               = `/api/member/inbody/options/`;
export const GET_MEMBER_INBODY_RESULT_PAGE           = (measureID) => `/api/member/inbody/${measureID}/info-page`;
export const GET_MEMBER_INBODY_TRANSCRIPT_PAGE       = (measureID) => `/api/member/inbody/${measureID}/transcript-page`;
export const GET_MEMBER_SINGLE_TRANSCRIPT_PAGE       = (tokenKey) => `/api/member/inbody/${tokenKey}/single-transcript-page`;
export const GET_MEMBER_MEASURE_BODY_EVALUATION      = (measureID) => `/api/member/inbody/${measureID}/evaluation`;            // 拿掉這個API
export const GET_MEMBER_MEASURE_BODY_EVALUATION_PAGE = (measureID) => `/api/member/inbody/${measureID}/evaluation-page`;

/* 量身明細及比較 */
export const GET_MEMBER_INBODY_RESULT                = (measureID) => `/api/member/inbody/${measureID}/`;
export const GET_MEMBER_INBODY_COMPARE_RECENT        = (measureID) => `/api/member/inbody/compare-recent`;
export const GET_MEMBER_INBODY_COMPARE_PAST          = (compareID) => `/api/member/inbody/compare-past?compareID=${compareID}`;

/* 量身主頁 */
export const GET_MEMBER_INBODY_DASHBOARD       = `/api/member/inbody/dashboard`;
export const GET_MEMBER_INBODY_DASHBOARD_TREND = (trendType) => `/api/member/inbody/dashboard/trend/${trendType}/chart`;

/* 教練量測 */
export const GET_EMPLOYEE_INBODY_OPTIONS     = `/api/employee/inbody/options/`;
export const GET_EMPLOYEE_INBODY_RESULT      = (measureID) => `/api/employee/inbody/${measureID}/`;
export const GET_EMPLOYEE_INBODY_RESULT_PAGE = (measureID) => `/api/employee/inbody/${measureID}/info-page`;

/* 運動次數 */
export const GET_MEMBER_WORKOUT_SUMMARY  = `/api/member/workout-summary/`;
export const GET_MEMBER_WORKOUT_CALENDAR = `/api/member/workout-calendar/`;

/* 兌換點數 */
export const GET_MEMBER_REWARD              = `/api/member/reward`;
export const GET_MEMBER_REWARD_REDEEM_CART  = `/api/member/reward/redeem-cart`;
export const POST_MEMBER_REWARD_REDEEM_CART = `/api/member/reward/redeem-cart`;
export const POST_MEMBER_REWARD_UN_REDEEM   = `/api/member/reward/un-redeem`;
export const GET_MEMBER_REWARD_RECORDS      = `/api/member/reward/records`;

/* 循環訂單 */
export const GET_MEMBER_CYCLE_PURCHASE_LIST            = `/api/member/cycle-purchase/`;
export const GET_MEMBER_CYCLE_PURCHASE_PRODUCTS        = `/api/member/cycle-purchase/products/`;
export const POST_MEMBER_CYCLE_PURCHASE_CHANGE_FLAVOR  = `/api/member/cycle-purchase/effection/change-flavor/`;
export const GET_MEMBER_CYCLE_PURCHASE_PENDING_CHANGES  = (cycleOrderID) => `/api/member/cycle-purchase/${cycleOrderID}/pending-changes/`;
export const GET_MEMBER_CYCLE_PURCHASE_EFFECTION        = (cycleOrderID, effectID) => `/api/member/cycle-purchase/${cycleOrderID}/effection/${effectID}/`;
export const DELETE_MEMBER_CYCLE_PURCHASE_EFFECTION     = (effectID) => `/api/member/cycle-purchase/effection/${effectID}`;

export const GET_PRIVACY = `/api/privacy/`;
